export default "__VITE_ASSET__BeIs106j__"